import * as Sentry from '@sentry/browser'
import { message as antMessage } from 'ant-design-vue'
import merge from 'lodash/merge'

import GLOBAL_ERROR_MSG from '@/config/errorMsg'

const DEFAULT_TYPE = 'error'
const DEFAULT_DURATION = 3

/**
 * 上报异常
 * @param {*} error 错误信息
 * @param {*} msg 错误提示语
 * @param {*} params 相关参数
 */
export function reportError(error, msg, params) {
  if (error) {
    try {
      Sentry.withScope(function(scope) {
        scope.setExtra('data', {
          data: error,
          params
        })
        Sentry.captureException(new Error(`【${document.title}】${msg}`))
      })
    } catch (error) {
      // do nothing
    }
  }
}

/**
 * 提示异常
 * @param {string} msg 错误信息
 * @param {string} type 错误类型
 */
export function showError(msg, type = DEFAULT_TYPE) {
  const msgKey = `${type}__${msg}`

  antMessage.open({
    content: msg,
    type,
    key: msgKey,
    duration: DEFAULT_DURATION
  })
}

/**
 * 格式化errCodeMap类型：
 * @return {*}: { [key]: {
 *    msg: string,
 *    needLog: boolean, 自定义是否记录错误
 *    type: string 自定义错误级别
 *  }
 * }
 */
export function formatErrCode(errCodeMap = {}) {
  if (typeof errCodeMap === 'string') {
    errCodeMap = {
      default: { msg: errCodeMap, type: DEFAULT_TYPE }
    }
  }

  const result = merge(
    {
      ...GLOBAL_ERROR_MSG,
      7: {
        msg: GLOBAL_ERROR_MSG[7],
        needLog: false,
        type: 'warning'
      },
      default: { msg: '系统内部错误', type: DEFAULT_TYPE }
    },
    errCodeMap
  )

  return Object.keys(result).reduce((res, key) => {
    let value = result[key]
    if (typeof value === 'string') {
      value = { msg: value, type: DEFAULT_TYPE }
    } else {
      value = Object.assign(
        {
          msg: '',
          type: DEFAULT_TYPE
        },
        value
      )
    }

    res[key] = value

    return res
  }, {})
}

/**
 * 处理 axios interceptors.request 出现的异常
 * @param {*} error 错误信息
 */
export function handleRequestError(error) {
  reportError(
    error,
    error.message,
    error.config
      ? {
          url: error.config.url,
          method: error.config.method,
          data: error.config.data
        }
      : {}
  )
  return { code: -2, msg: error.message }
}

/**
 * 处理 axios interceptors.response 出现的异常
 * @param {*} error 错误信息
 */
export function handleReponseError(error) {
  if (error.message === 'Network Error') {
    showError('您的网络好像有点问题, 请重试')
    return { code: -3, msg: error.message }
  }

  // 如果是主动取消的请求
  if (error.__CANCEL__) {
    return { code: -3, msg: '请求已取消', __CANCEL__: true }
  }

  reportError(
    error,
    error.msg,
    error.config
      ? {
          url: error.config.url,
          method: error.config.method,
          data: error.config.data
        }
      : {}
  )

  return { code: -3, msg: error.message }
}
